// actions.js
import * as actionTypes from "./actionsTypes";

export const setValueInvestisseurs = (newValue) => ({
  type: actionTypes.SET_VALUE_INVESTISSEUR,
  payload: newValue,
});

export const setCurrentPageInvestisseurs = (newCurrentPage) => ({
  type: actionTypes.SET_CURRENT_PAGE_INVESTISSEUR,
  payload: newCurrentPage,
});

export const setSortingInvestisseurs = (newSorting) => ({
  type: actionTypes.SET_SORTING_INVESTISSEUR,
  payload: newSorting,
});
export const setPageSizeInvestisseurs = (newValue) => ({
  type: actionTypes.SET_PAGE_SIZE_INVESTISSEUR,
  payload: newValue,
});

export const setCustomFilterInvestisseurs = (newValue) => ({
  type: actionTypes.SET_CUSTOM_FILTERS_INVESTISSEUR,
  payload: newValue,
});
export const setSortFieldInvestisseurs = (newSortField) => ({
  type: actionTypes.SET_SORT_FIELD_INVESTISSEUR,
  payload: newSortField,
});
export const setOrderInvestisseurs = (newOrder) => ({
  type: actionTypes.SET_ORDER_INVESTISSEUR,
  payload: newOrder,
});
export const setActiveTabInvestisseurs = (newActiveTab) => ({
  type: actionTypes.SET_ACTIVE_TAB_INVESTISSEUR,
  payload: newActiveTab,
});
export const setQueryInvestisseurs = (newQuery) => ({
  type: actionTypes.SET_QUERY_INVESTISSEUR,
  payload: newQuery,
});
export const setActifInvestisseurs = (newQuery) => ({
  type: actionTypes.SET_ACTIF_INVESTISSEUR,
  payload: newQuery,
});
export const setSelectedOptionFiltersInvestisseurs = (newQuery) => ({
  type: actionTypes.SET_SELECTED_OPTION_FILTERS_INVESTISSEUR,
  payload: newQuery,
});
export const setSelectedOptionIdInvestisseurs = (newQuery) => ({
  type: actionTypes.SET_SELECTED_OPTION_ID_INVESTISSEUR,
  payload: newQuery,
});

export const setColumnInvestisseurs = (newValue) => ({
  type: actionTypes.SET_COLUMN_INVESTISSEUR,
  payload: newValue,
});
